import React from "react";
import { motion } from "framer-motion";
import { MapPin, Navigation } from "lucide-react";
import { CLINIC, CLINIC_PHOTOS } from "@/data/constants";

const SPANS = [
  "sm:col-span-2 sm:row-span-2",
  "",
  "",
  "",
  "sm:col-span-2",
];

export const ClinicGallery = () => {
  return (
    <section id="clinic" className="max-w-7xl mx-auto px-5 sm:px-8 py-20 scroll-mt-24" data-testid="clinic-section">
      <div className="text-center max-w-2xl mx-auto">
        <span className="text-gold-dark font-700 text-sm uppercase tracking-wider">Our Clinic</span>
        <h2 className="font-heading text-4xl sm:text-5xl text-sage-900 tracking-tight mt-2">
          Step Inside Kalpataru Dental Care
        </h2>
        <p className="text-sage-600 mt-3">
          A clean, modern and welcoming space designed for your comfort — from our reception
          to fully-equipped treatment rooms.
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 mt-12">
        {CLINIC_PHOTOS.map((p, i) => (
          <motion.figure
            key={i}
            initial={{ opacity: 0, scale: 0.97 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.08 }}
            data-testid={`clinic-photo-${i}`}
            className="group relative overflow-hidden rounded-2xl border border-sage-200 shadow-sm h-64"
          >
            <img
              src={p.url}
              alt={p.caption}
              loading="lazy"
              className="img-enhance h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-sage-900/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
            <figcaption className="absolute bottom-0 left-0 right-0 p-4 text-white font-600 text-sm translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
              {p.caption}
            </figcaption>
          </motion.figure>
        ))}
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-10">
        <span className="text-sage-600 text-sm inline-flex items-center gap-2">
          <MapPin size={16} className="text-gold-dark" /> {CLINIC.address}
        </span>
        <a
          href={CLINIC.mapsLink}
          target="_blank"
          rel="noreferrer"
          data-testid="clinic-directions-btn"
          className="inline-flex items-center gap-2 text-gold-dark font-700 text-sm hover:underline"
        >
          <Navigation size={15} /> Get Directions
        </a>
      </div>
    </section>
  );
};
